import chroma from "chroma-js";

const contrastingColour = (colour, { white = "#fff", black = "#333" } = {}) => {
  const contrastWithWhite = chroma.contrast(colour, white);
  return contrastWithWhite >= 4 ? white : black;
};

export default ({ primaryColour, secondaryColour, bgColour, hasScheme }) => {
  if (!hasScheme) {
    return "";
  }

  const darkPrimaryColour = chroma(primaryColour)
    .darken(0.4)
    .hex();
  const darkSecondaryColour = chroma(secondaryColour)
    .darken(0.4)
    .hex();
  // const lightSecondaryColour = chroma(secondaryColour).brighten(0.2).hex()
  const darkBgColour = chroma(bgColour)
    .darken(0.1)
    .hex();
  const extraDarkBgColour = chroma(darkBgColour)
    .darken(0.9)
    .hex();

  const contrasting = {
    primary: contrastingColour(primaryColour),
    secondary: contrastingColour(secondaryColour),
    darkBg: contrastingColour(darkBgColour)
  };

  return `
    .el-button.el-button--primary {
      background-color: ${primaryColour};
      color: ${contrasting.primary} !important;
      border: 1px solid ${chroma(primaryColour)
        .darken(0.5)
        .hex()} !important;
    }

    .el-button.el-button--primary:hover {
      background-color: ${chroma(primaryColour)
        .darken(0.5)
        .hex()};
      color: ${contrasting.primary} !important;
    }

    .el-button.el-button--default:hover {
      border-color: ${primaryColour} !important;
      color: ${primaryColour} !important;
    }

    .el-button.el-button--default:hover {
      border-color: ${primaryColour} !important;
      color: ${primaryColour} !important;
    }

    .el-pagination .number.active {
      background-color: ${secondaryColour} !important;
      border-color: transparent !important;
      color: ${contrasting.secondary} !important;
    }

    .el-table th, .el-table__header-wrapper thead div {
      background-color: ${darkBgColour} !important;
      color: ${contrasting.darkBg} !important;
    }

    .el-table .sort-caret.ascending {
      border-bottom-color: ${extraDarkBgColour} !important;
    }

    .el-table .sort-caret.descending {
      border-top-color: ${extraDarkBgColour} !important;
    }

    .sidenav a {
      color: ${contrasting.secondary} !important;
    }

    .sidenav .router-link-active a, .sidenav .router-link-exact-active a, .sidenav .router-link-active, .sidenav .router-link-exact-active {
      background: ${darkSecondaryColour} !important;
      border-right-color: ${primaryColour} !important;
    }

    .logo {
      color: ${contrasting.secondary} !important;
      background-color: ${chroma(secondaryColour)
        .darken(0.8)
        .hex()} !important;
    }

    .sidebar {
      border-right: 1px solid ${chroma(secondaryColour)
        .darken(0.2)
        .hex()} !important;
      background-color: ${secondaryColour} !important;
    }

    .sidenav .item {
      border-bottom-color: ${chroma(secondaryColour)
        .darken(0.4)
        .hex()} !important;
    }

    .sidenav .item a:hover {
      background: ${chroma(secondaryColour)
        .brighten(0.4)
        .hex()} !important;
    }

    .sidenav .item .label {
      color: ${contrasting.secondary} !important;
    }

    .topbar {
      border-bottom: 1px solid ${darkPrimaryColour} !important;
      color: ${contrasting.primary} !important;
    }

    .topbar .app {
      border-left-color: ${darkPrimaryColour} !important;
      color: ${contrasting.primary} !important;
    }

    .topbar .app:last-child {
      border-right-color: ${darkPrimaryColour} !important;
    }

    .topbar .app.active {
      background: ${darkPrimaryColour} !important;
    }

    .main-app-content {
      background-color: ${bgColour} !important;
    }
  `;
};
